export default defineNuxtRouteMiddleware((to) => {
  if (
    import.meta.server ||
    (to.meta.includeRoles === undefined &&
      to.meta.excludesRoles === undefined)
  ) {
    return;
  }

  const authStore = useAuthStore();

  if (!authStore.hasNavigationRoleAccess(to.meta)) {
    throw showError({
      statusCode: 403,
      statusMessage: "ไม่มีสิทธิ์เข้าถึง",
    });
  }
});
